<template>
  <section>
    <VerReportePorUnidadGestion />
    <AprobarUnidadesProgramacionJefeJerarquico />
    <h3 class="primary--text">
      <v-icon color="primary">people</v-icon>
      Vacaciones
    </h3>
    <!-- Boton aprobar no dependencia   v-if="this.user.unidad[0].id != this.$route.params.id_unidad"-->
    <v-tooltip bottom>
      <v-btn
        :disabled="!this.valida_programacion"
        color="rgba(103,15,121,0.6)"
        @click="aprobarUnidadesProgramacionJefeJerarquico({})"
        slot="activator"
        ><v-icon dark>play_arrow</v-icon>Aprobar programación
      </v-btn>
      <span>Aprobar</span>
    </v-tooltip>
    <v-card elevation="0">
      <v-progress-circular
        v-if="loading_tabla"
        :size="200"
        :width="15"
        color="purple"
        indeterminate
      ></v-progress-circular>
      <v-card-text v-if="!loading_tabla">
        <v-layout>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = !filterShow;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
        </v-layout>
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Dependencia"
                  v-model="form.nombre_unidad"
                  @input="filterNombreUnidad"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <!-- <v-text-field
                  label="Estado"
                  v-model="form.estado"
                  @input="filterEstado"
                ></v-text-field> -->
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                        recargar();
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_unidades"
          no-data-text="Sin datos"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[25, 50, { text: 'Todos', value: -1 }]"
        >
          <!-- Cabecera -->
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" >
                  {{ props.header.text }}
                </span>
              </template>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:items="items">
            <td
              class="text-xs-center"
              :id="user.unidad[0].id == items.item.id_unidad ? 'celda' : ''"
            >
              {{ items.item.nombre_unidad }}
            </td>
            <!-- <td
              class="text-xs-center"
              :id="user.unidad[0].id == items.item.id_unidad ? 'celda' : ''"
            >
              {{ items.item.estado }}
            </td> -->
            <td
              :id="user.unidad[0].id == items.item.id_unidad ? 'celda' : ''"
              class="text-xs-center"
            >
              <v-btn
                color="#6DE0BA"
                dark
                icon
                title="Ver programaciones de vacaciones"
                :to="
                  `/ver-detalle-programacion-jerarquico/${
                    $route.params.gestion
                  }/${items.item.id_unidad}/${$util.encodeString(
                    items.item.nombre_unidad
                  )}/${$util.encodeString(
                    items.item.item_jefe != '' ? items.item.item_jefe : '10001'
                  )}`
                "
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!-- <v-btn
                v-if="
                  user.unidad[0].id != items.item.id_unidad &&
                    items.item.aprueba == 1
                "
                color="#33FB9E"
                @click.prevent="aprobarRechazarProgramacion(1, items.item)"
                icon
                title="Aprobar"
              >
                <v-icon>done</v-icon>
              </v-btn> -->
              <!-- <v-btn
                v-if="
                  user.unidad[0].id != items.item.id_unidad &&
                    items.item.aprueba == 1
                "
                color="#FF5D34"
                @click.prevent="aprobarRechazarProgramacion(0, items.item)"
                icon
                title="Rechazar"
              >
                <v-icon>close</v-icon>
              </v-btn> -->
              <v-btn
                v-if="user.unidad[0].id != items.item.id_unidad"
                color="warning"
                @click.prevent="verReportePorUnidadGestion(items.item, 1)"
                icon
                title="Ver reporte de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

              <v-btn
                v-if="user.unidad[0].id == items.item.id_unidad"
                color="warning"
                @click.prevent="verReportePorUnidadGestion(items.item, 5)"
                icon
                title="Ver reporte de vacación"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

              <!-- <v-chip
                :color="items.item.aprueba == 0 ? 'purple' : 'green'"
                dark
                :title="
                  items.item.aprueba == 0
                    ? 'Aun faltan solicitudes'
                    : 'Programado'
                "
                v-if="items.item.aprueba == 0 || items.item.aprueba == 2"
              >
                {{ items.item.aprueba == 0 ? "Pendiente" : "Programado" }}
              </v-chip> -->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import AprobarUnidadesProgramacionJefeJerarquico from "./dialogs/AprobarUnidadesProgramacionJefeJerarquico";
import filtros from "./mixins/filtrosUnidades";
import VerReportePorUnidadGestion from "./dialogs/VerReportePorUnidadGestion";
export default {
  mixins: [crud, filtros],
  data() {
    return {
      //active: "datos-personales-basicos",
      form: {},
      loading_tabla: true,
      persona: null,
      loading: false,
      img_url: "",
      funcionario: null,
      selected: [],
      selected_uso: [],
      filterShow: true,
      lista_funcionarios: [],
      id_estado_programacion: null,
      filters: {
        nombre_unidad: "",
        estado: ""
      },
      graphql: true,
      // Cabecera de la tabla
      initData: [
        {
          state: true,
          param: "id_jefe",
          value: this.$storage.get("user").id_persona
        }
      ],
      headers: [
        {
          text: "Dependencia",
          value: "nombre_unidad",
          align: "center",
          class: "header"
        },
        // {
        //   text: "Estado",
        //   value: "estado",
        //   align: "center",
        //   class: "header"
        // },
        {
          text: this.$t("common.actions"),
          sortable: false,
          align: "center",
          class: "header"
        }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
         id
        id_jefe
        id_estado
        fecha_desde
        fecha_hasta
        fecha_solicitud
        id_persona
        nro_doc
        funcionario
        estado
        total_dias
        unidad
        id_unidad

      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      lista_unidades: [],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      persona: null,
      saldo: null,
      periodo: null,
      user: this.$storage.get("user"),
      id_programacion: null,
      //Varibale para validar elboton de aprobacion
      valida_programacion: true
    };
  },
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarUnidades();
    await this.obtieneIdProgramacion();
    await this.validarProgramacion();
    this.onFilter();
    this.id_estado_programacion = await this.$service.obtenerEstadoProgramación(
      parseInt(this.$route.params.gestion)
    );
    this.$bus.$on(
      "closeDialogAprobarProgramacionSuperiorJerarquico",
      async () => {
        this.updateList();
        await this.validarProgramacion();
      }
    );
    this.$bus.$on(
      "closeDialogAprobarUnidadesProgramacionJefeJerarquico",
      async () => {
        this.updateList();
        await this.validarProgramacion();
      }
    );
    this.$bus.$on("closeDialogVerReportePorUnidadesGestion", () => {});

    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
  },

  methods: {
    // Metodo para verificar si todos los funcionarios de la dependencia tienen sus vacaciones programadas (estado 54) VALIDAR BOTON
    async validarProgramacion() {
      let user = this.$storage.get("user");
      try {
        let res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT vacaciones.fn_verifica_vacacion_programada(${user.id_persona}, ${this.$route.params.gestion}, ${user.id})"){
								respuesta
							}
							}
						`
        });
        let respuesta =
          res.runQuery.respuesta[0].fn_verifica_vacacion_programada;
        if (respuesta == "1") {
          //no existen opersonas por aprobar
          this.valida_programacion = false;
        } else {
          this.valida_programacion = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para verificar si todos los funcionarios de la unidad enviaron programaciones
    async verificaEnviadoFuncionario(id_unidad) {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select * FROM vacaciones.fn_vacaciones_por_unidad_sin_jefe(${parseInt(
                id_unidad
              )},${parseInt(
            this.$route.params.gestion
          )})AS (id_persona integer,id_unidad integer,nombres text,id_estado_programacion integer,nombre_unidad varchar,id_estado_vacacion integer,id_programacion integer,periodo integer)"){
                respuesta
              }
            }
          `
        });
        let bandera_aprobacion = 1;
        let listado_funcionarios = res.runQuery.respuesta;
        listado_funcionarios.forEach(element => {
          if (element.id_estado_programacion == 54) {
            bandera_aprobacion = 2;
            return;
          }
          if (element.id_estado_programacion != 66) {
            bandera_aprobacion = 0;
            return;
          }
        });
        return bandera_aprobacion;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para cargar el listado de funcionarios
    async cargarFuncionarios() {
      try {
        let res = [];
        let user = this.$storage.get("user");
        for (let i = 0; i < this.lista_unidades.length; i++) {
          const element = this.lista_unidades[i];
          if (user.unidad[0].id == element.id_unidad) {
            let item = await this.obtenerItem();

            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad_jerarquicos(${this.$route.params.id_unidad},${this.$route.params.gestion},${user.id_persona})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          }
        }
        if (user.unidad[0].id && this.$route.params.id_unidad) {
          if (user.unidad[0].id == this.$route.params.id_unidad) {
            let item = await this.obtenerItem();

            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad_jerarquicos(${this.$route.params.id_unidad},${this.$route.params.gestion},${user.id_persona})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          } else {
            res = await this.$service.graphql({
              query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_vacaciones_por_unidad(${this.$route.params.id_unidad},${this.$route.params.gestion})AS(id_unidad integer,servidor_publico TEXT,fecha_incorporacion date,saldo_corte NUMERIC,dias_saldo_a NUMERIC,dias_saldo_b NUMERIC,dias_saldo_c NUMERIC,	total_dias_saldo numeric,dias_no_programados numeric,dias_asignados NUMERIC,vac_adquirida varchar,dias_programar varchar,total_programacion NUMERIC,ene TEXT,feb TEXT,mar TEXT,abr TEXT,may TEXT,jun TEXT,jul TEXT,ago TEXT,sep TEXT,oct TEXT,nov TEXT,dic TEXT,estado TEXT,id_estado_vacac_progra INTEGER,id_persona integer)"){
								respuesta
							}
							}
						`
            });
          }
          res = res.runQuery.respuesta;
          this.lista_funcionarios_vacaciones = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtner el id de la programacion - tabla programacion
    async obtieneIdProgramacion() {
      try {
        let res = await this.$service.graphql({
          query: `
          query{
            programacions(gestion:${parseInt(this.$route.params.gestion)}){
              rows{
                id
                gestion
                porcentaje
                fecha_corte
                fecha_inicio
                fecha_fin
                fecha_ampliacion
                id_estado
              }
            }
          }
          `
        });
        this.id_programacion = res.programacions.rows[0].id;
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para aprobar la programacion de todas las unidades
    async aprobarUnidadesProgramacionJefeJerarquico(item) {
      // let item= {}
      // item.nro_item= await this.obtenerItem()
      this.$bus.$emit(
        "openDialogAprobarUnidadesProgramacionJefeJerarquico",
        item
      );
    },
    // async aprobarRechazarProgramacion(aprueba, item) {
    //   let id_estado_aprobacion;
    //   let mensaje = "";
    //   if (aprueba == 1) {
    //     id_estado_aprobacion = 54;
    //     mensaje = "¿Está seguro de aprobar la programación?";
    //   } else {
    //     id_estado_aprobacion = 47;
    //     mensaje = "¿Está seguro de rechazar la programación?";
    //   }
    //   let respuesta;
    //   let resps = [];
    //   let correcto = true;
    //   this.loading = true;
    //   this.$confirm(mensaje, async () => {
    //     try {
    //       respuesta = await this.$service.graphql({
    //         query: `
    //         query{
    //           runQuery(consulta:"select vacaciones.fn_aprueba_rechaza_por_unidad_jerarquico(${parseInt(
    //             item.id_unidad
    //           )},${parseInt(
    //           this.id_programacion
    //         )},${id_estado_aprobacion},${parseInt(this.user.id)})"){
    //             respuesta
    //           }
    //         }
    //       `
    //       });
    //       respuesta =
    //         respuesta.runQuery.respuesta[0]
    //           .fn_aprueba_rechaza_por_unidad_jerarquico;
    //       resps = respuesta.split("|");
    //       correcto = resps[0];
    //       if (correcto == "1") {
    //         this.$message.success(resps[1]);
    //       } else {
    //         this.$message.error(resps[1]);
    //       }
    //     } catch (error) {
    //       console.log(error);
    //     }
    //     this.loading = false;
    //   });
    // },

    // Metodo para cargar el listado de unidades
    async cargarUnidades() {
      let user = this.$storage.get("user");
      try {
        let res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT * FROM vacaciones.fn_lista_unidades_por_jerarquico(${user.id_persona})AS(id_unidad integer, nombre_unidad varchar, id_unidad_jefe varchar, item_jefe varchar)"){
								respuesta
							}
							}
						`
        });

        let lista_unidades_pre = res.runQuery.respuesta;
        this.loading_tabla = false;
        this.lista_unidades = lista_unidades_pre;
      } catch (error) {
        console.log(error);
      }
    },
    getAño() {
      let año = new Date().getFullYear() + "";
      return año;
    },

    getId(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }

      return sw;
    },
    // Selecciona o desmarcar checkbox aprobacion uso de vacacion
    getIdUso(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected_uso.length; i++) {
        const element = this.selected_uso[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected_uso.splice(index, 1);
      } else {
        this.selected_uso.push(id);
      }
      return sw;
    },
    async seleccionarTodo() {
      let usuario = this.$storage.get("user").id_persona;
      let lista_seleccion = [];
      let resp = await this.$service.graphql({
        query: `
          query{
            vVacasPendientesMayorAJefes(lista_estados:"44,51",id_jefe:${usuario}){
              rows {
               id
                  id_jefe
                  id_estado
                  fecha_desde
                  fecha_hasta
                  fecha_solicitud
                  id_persona
                  nro_doc
                  funcionario
                  estado
                  total_dias

              }
            }
          }
        `
      });

      lista_seleccion = resp.vVacasPendientesMayorAJefes.rows;

      for (let index = 0; index < lista_seleccion.length; index++) {
        const element = lista_seleccion[index];

        let sw = false;
        for (let i = 0; i < this.selected.length; i++) {
          const element2 = this.selected[i];
          if (element.id == element2) {
            sw = true;
            break;
          }
        }
        if (!sw) {
          this.selected.push(element.id);
        }
      }
    },

    deseleccionarTodo() {
      this.selected = [];
      this.selected_uso = [];
    },

    verifica(id) {
      return this.selected.includes(id);
    },
    verifica_uso(id) {
      return this.selected_uso.includes(id);
    },
    async verReportePorUnidadGestion(item, valor) {
      await this.obtieneIdProgramacion();
      item.id_estado = this.id_estado_programacion;

      if (this.user.nro_item == "10001") {
        item.item_jefe = "10001";
      }
      item.id_unidad = parseInt(item.id_unidad);
      item.valor = valor;
      this.$bus.$emit("openDialogVerReportePorUnidadGestion", item);
    }
  },
  components: {
    CrudTable,
    AprobarUnidadesProgramacionJefeJerarquico,
    VerReportePorUnidadGestion
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/VacacionAprobarJefe2.vue